import { StateCreator } from "zustand";
import { CommonEntity, StateType } from "store/entities";

export const createCommonSlice: StateCreator<
  StateType,
  [],
  [],
  CommonEntity
> = (set) => ({
  userInfo: null,
  countryCodes: [],
  headerTitle: null,
  setUserInfo: (newState) => set((state) => ({ userInfo: newState })),
  setHeaderTitle: (newState) => set((state) => ({ headerTitle: newState })),
  setCountryCodes: (newState) => set((state) => ({ countryCodes: newState })),
});
